import { registerModal } from 'features/Modal/ModalRegistry'
import { PhoneSystemHuntGroupEditFormModal } from './PhoneSystemHuntGroupEditFormModal'
import { showModal } from 'features/Modal/Modal.actions'
import { IHuntGroupFormData } from '../PhoneSystemHuntGroupEditForm/PhoneSystemHuntGroupEditForm.container'

export const modalType = 'PHONE_SYSTEM_HUNT_GROUP_EDIT_FORM_MODAL'
registerModal(modalType, PhoneSystemHuntGroupEditFormModal)
export const showPhoneSystemHuntGroupEditFormModal = (modalProps: IHuntGroupFormData) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemHuntGroupEditFormModal/PhoneSystemHuntGroupEditFormModal.action.ts